export enum RoleTypes {
	guest = 'lta_guest',
	admin = 'lta_admin',
}
